import Vue from 'vue'
import VueRouter from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(VueRouter)


const router = new VueRouter({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorlds
    // }
    {
      path: '/',
      name: 'home',
      meta: { title: '歌力思集团' },
      component: () => import('../views/home.vue')
    },
    {
      path: '/sas',
      name: 'sass',
      meta: { title: '歌力思集团' },
      component: () => import('../views/subBrand/test.vue')
    },
    {
      path: '/groupIntroduce',
      name: 'groupIntroduce',
      meta: { title: '集团介绍' },
      component: () => import('../views/subContent/groupIntroduce.vue')
    },
    {
      path: '/brandClassify',
      name: 'brandClassify',
      meta: { title: '品牌分类' },
      component: () => import('../views/brandClassify.vue')
    },
    {
      path: '/history',
      name: 'history',
      meta: { title: '集团发展史' },
      component: () => import('../views/subContent/history.vue')
    },
    {
      path: '/subBrand',
      name: 'subBrand',
      meta: { title: 'ellassay品牌介绍' },
      component: () => import('../views/subBrand/ellassay.vue')
    },
    {
      path: '/L-subBrand',
      name: 'L-subBrand',
      meta: { title: 'laurel品牌介绍' },
      component: () => import('../views/subBrand/laurel.vue')
    },
    {
      path: '/Ed-subBrand',
      name: 'Ed-subBrand',
      meta: { title: 'Ed Hardy品牌介绍' },
      component: () => import('../views/subBrand/edHardy.vue')
    },
    {
      path: '/IRO-subBrand',
      name: 'IRO-subBrand',
      meta: { title: 'IRO品牌介绍' },
      component: () => import('../views/subBrand/iro.vue')
    },
    {
      path: '/selfPortait-subBrand',
      name: 'selfPortait-subBrand',
      meta: { title: 'self-portait品牌介绍' },
      component: () => import('../views/subBrand/sp.vue')
    },
    {
      path: '/nobis-subBrand',
      name: 'nobis-subBrand',
      meta: { title: 'nobis品牌介绍' },
      component: () => import('../views/subBrand/nobis.vue')
    },
    {
      path: '/release',
      name: 'release',
      meta: { title: '品牌发布会' },
      component: () => import('../views/subBrand/release.vue')
    },//eleaseVideo
    {
      path: '/releaseVideo',
      name: 'releaseVideo',
      meta: { title: '发布会' },
      component: () => import('../views/subBrand/releaseVideo.vue')
    },
    {
      path: '/advertisement',
      name: 'advertisement',
      meta: { title: '广告大片' },
      component: () => import('../views/subBrand/advertisement.vue')
    },
    {
      path: '/friend',
      name: 'friend',
      meta: { title: '品牌好友' },
      component: () => import('../views/subBrand/friend.vue')
    },
    {
      path: '/susFashion',
      name: 'susFashion',
      meta: { title: '可持续时尚' },
      component: () => import('../views/susFashion/index.vue')
    },
    {
      path: '/personalTailor',
      name: 'personalTailor',
      meta: { title: '团体定制' },
      component: () => import('../views/personalTailor/index.vue')
    },
    {
      path: '/meta',
      name: 'meta',
      meta: { title: 'meta ellassay' },
      component: () => import('../views/meta/index.vue')
    },
    {
      path: '/beast',
      name: 'beast',
      meta: { title: '野兽' },
      component: () => import('../views/otherCompany/beast.vue')
    },
    {
      path: '/law',
      name: 'law',
      meta: { title: '法律申明' },
      component: () => import('../views/law/index.vue')
    },
    // {
    //   path: '/index',
    //   name: 'index',
    //   meta: { title: '滚动' },
    //   component: () => import('../views/index.vue')
    // },
  ],
  scrollBehavior(to,from,savePosition){
    return {
      x:0,
      y:0
    }
  }
})
router.beforeEach((to, from, next) => {
  document.title=to.meta.title
  // if (to.path) {
  //     console.log('跳进来')
  //     _hmt.push(['_trackPageview',to.fullPath]);
  // }
  next()
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js